import React from 'react';
import { useLicense } from '../context/LicenseContext';
import { AlertTriangle, Clock, Shield, X } from 'lucide-react';

const LicenseWarningBanner = () => {
  const { isExpired, isWarning, isTampered, licenseRemaining, isActivated, licenseStatus } = useLicense();
  const [dismissed, setDismissed] = React.useState(false);

  if (dismissed) return null;
  if (!isExpired && !isWarning && !isTampered) return null;

  let bgColor, borderColor, textColor, icon, message;

  if (isTampered) {
    bgColor = 'bg-rose-50 dark:bg-rose-900/30';
    borderColor = 'border-rose-300 dark:border-rose-700';
    textColor = 'text-rose-800 dark:text-rose-200';
    icon = <AlertTriangle className="h-5 w-5 text-rose-500 shrink-0" />;
    message = 'Security violation detected. Contact your administrator.';
  } else if (isExpired) {
    bgColor = 'bg-rose-50 dark:bg-rose-900/30';
    borderColor = 'border-rose-300 dark:border-rose-700';
    textColor = 'text-rose-800 dark:text-rose-200';
    icon = <Shield className="h-5 w-5 text-rose-500 shrink-0" />;
    message = 'License has expired. Only admin login is available. Contact your administrator to renew.';
  } else if (isWarning) {
    bgColor = 'bg-amber-50 dark:bg-amber-900/30';
    borderColor = 'border-amber-300 dark:border-amber-700';
    textColor = 'text-amber-800 dark:text-amber-200';
    icon = <Clock className="h-5 w-5 text-amber-500 shrink-0" />;
    message = `License expires in ${licenseRemaining} day${licenseRemaining !== 1 ? 's' : ''}. Contact your administrator to renew.`;
  }

  return (
    <div className={`${bgColor} ${borderColor} border px-4 py-3 flex items-center gap-3`} data-testid="license-warning-banner">
      {icon}
      <p className={`text-sm font-medium ${textColor} flex-1`}>{message}</p>
      {isWarning && (
        <button onClick={() => setDismissed(true)} className="text-slate-400 hover:text-slate-600">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default LicenseWarningBanner;
